module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_04a.3a0e9bf8.jpg";